


















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ConditionState} from '@/types/gripper';
import 'vue-sweetalert2/dist/index';
import {JobDataset_job_dataset_conditions} from '@/types/intrador';


@Component({
  components: {},
})
export default class ConditionsSelector extends Vue {

  @Prop(Array) public conditions!: JobDataset_job_dataset_conditions[];

  private conditionsStates: ConditionState[] = [];
  private resourceID: string | null = null;
  private dialog: boolean = false;
  private colors = ['red', 'indigo', 'orange', 'primary', 'secondary', 'success', 'info',
    'warning', 'error', 'red darken-3', 'indigo darken-3', 'orange darken-3'];


  public open(resourceID: string | null) {
    this.dialog = true;
    this.resourceID = resourceID;
  }

  public finish() {
    this.$emit('onFinishSelectingConditions', this.conditionsStates, this.resourceID);
  }

  get getRandomColor() {
    return this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  // for every condition, create a ConditionState object to manage it's UI state.
  private created() {
    this.conditions.forEach((condition: JobDataset_job_dataset_conditions) => {
      this.conditionsStates.push(
        {
          id: condition.id,
          doCreateNegative: true,
        } as ConditionState,
      );
    });
  }

  private getConditionState(condition: ConditionState) {
    return this.conditionsStates.find((c: ConditionState) => c.id === condition.id);
  }

  private closeDialog() {
    this.dialog = false;
  }

  private async createNegatives() {
    this.finish();
    this.dialog = false;
  }

  @Watch('dialog')
  private watchModalClose(dialog: boolean) {
    if (dialog === false) {
      this.$emit('onEndBulkDeleteUIMode');
    }
  }

}
